import { useEffect, useState } from "react";
import { Instagram, Mail } from "lucide-react";
import { api } from "@/lib/api";

export const ContactLinks = ({ testId = "contact", className = "" }) => {
  const [contact, setContact] = useState(null);
  useEffect(() => { let active = true; api.get("/config/contact").then(({ data }) => { if (active) setContact(data); }).catch(() => {}); return () => { active = false; }; }, []);
  if (!contact) return null;
  return <nav aria-label="Contact NxT" data-testid={`${testId}-links`} className={`flex flex-wrap items-center justify-end gap-x-5 gap-y-2 text-xs text-muted-foreground ${className}`}>
    <a data-testid={`${testId}-email`} href={`mailto:${contact.email}`} className="inline-flex items-center gap-1.5 transition-colors hover:text-indigo-700"><Mail className="h-3.5 w-3.5" />Feedback & support</a>
    <a data-testid={`${testId}-instagram`} href={contact.instagram_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 transition-colors hover:text-indigo-700"><Instagram className="h-3.5 w-3.5" />@nxt.career</a>
  </nav>;
};
